import { FullscreenButton } from "@cesium/widgets";

/**
 * 전체 화면 모드 단일 버튼 위젯.</br>
 * A single button widget for toggling fullscreen mode.
 *
 * @extends FullscreenButton
 *
 * @alias DitapFullscreenButton
 * @constructor
 *
 *
 * @constructor
 * @param {Element|string} container 위젯을 포함할 DOM 요소 또는 ID.</br>
 * The DOM element or ID that will contain the widget.
 * 
 * @example

* const viewer = new Ditap.DitapViewer("ditapContainer");
* const container = viewer.container;
* 
* const navigationHelpContainer= container.getElementsByClassName(
*     "js-ditap-toolbal-right-btn-wrap"
*  )[0]; 
*
* new Ditap.DitapFullscreenButton(
*   navigationHelpContainer
* );
 */
class DitapFullscreenButton extends FullscreenButton {
  constructor(viewer, fullscreenElement) {
    const container = viewer.toolbarRightBtn;
    const mobileContainer = viewer.mobileBtnContainer;

    super(container, fullscreenElement);

    const currentWidth = window.innerWidth;

    if (this.viewModel.isFullscreenEnabled) {
      const fullscreenButton = container.getElementsByClassName(
        "cesium-fullscreenButton"
      )[0];

      fullscreenButton.firstElementChild.remove();

      if (fullscreenButton.classList.contains("cesium-fullscreenButton")) {
        fullscreenButton.classList.remove("cesium-fullscreenButton");
      }
      if (fullscreenButton.classList.contains("cesium-button")) {
        fullscreenButton.classList.remove("cesium-button");
      }
      // if (!fullscreenButton.classList.contains("ditap-toolbar-btn")) {
      //   fullscreenButton.classList.add("ditap-toolbar-btn");
      // }
      if (!fullscreenButton.classList.contains("ditap-full-btn")) {
        fullscreenButton.classList.add("ditap-full-btn");
      }
      fullscreenButton.removeAttribute("title");

      const li = document.createElement("li");
      li.classList.add("ditap-func-btn-item");

      if (currentWidth <= 600) {
        li.appendChild(fullscreenButton);
        // mobileContainer.appendChild(li);
        mobileContainer
          .querySelector(".js-position-fullscreen")
          .appendChild(li);
        fullscreenButton.classList.add("ditap-mobile-btn");
      } else {
        fullscreenButton.classList.add("ditap-toolbar-btn");
        container.appendChild(fullscreenButton);
      }

      const p1 = document.createElement("p");
      const p2 = document.createElement("p");

      p1.classList.add("ditap-function-btn-img");
      p2.classList.add("ditap-btn-tooltip");
      p2.textContent = "전체화면";

      fullscreenButton.appendChild(p1);
      fullscreenButton.appendChild(p2);

      const resizeOriginal = () => {
        // 윈도우의 현재 너비를 확인
        const currentWidth = window.innerWidth;
        if (currentWidth <= 600) {
          li.appendChild(fullscreenButton);
          // mobileContainer.appendChild(li);
          mobileContainer
            .querySelector(".js-position-fullscreen")
            .appendChild(li);
          fullscreenButton.classList.add("ditap-mobile-btn");
          fullscreenButton.classList.remove("ditap-toolbar-btn");
        } else {
          fullscreenButton.style.display = "flex";
          fullscreenButton.classList.remove("ditap-mobile-btn");
          fullscreenButton.classList.add("ditap-toolbar-btn");
          container.appendChild(fullscreenButton);
        }
      };
      this._resizeEvent = () => {
        resizeOriginal();
        setTimeout(resizeOriginal, 500);
      };
      window.addEventListener("resize", this._resizeEvent);

      this.fullscreenButton = p1;
      const that = this;
      document.addEventListener("fullscreenchange", () => {
        that.handleFullscreenChange();
      });
      document.addEventListener("webkitfullscreenchange", () => {
        that.handleFullscreenChange();
      });
      document.addEventListener("mozfullscreenchange", () => {
        that.handleFullscreenChange();
      });
      document.addEventListener("MSFullscreenChange", () => {
        that.handleFullscreenChange();
      });
      document.addEventListener("keydown", this.documentKeydown);
    } else {
      const fullscreenButton = container.getElementsByClassName(
        "cesium-fullscreenButton"
      )[0];
      fullscreenButton.style = "display:none";
    }
  }

  /**
   * 전체화면 상태 변경 이벤트 감지하여 전체화면 버튼 상태 업데이트.<br>
   * Detect fullscreen state change events to update the fullscreen button state.
   */
  handleFullscreenChange() {
    const fullscreenButton = this.fullscreenButton;

    if (this.viewModel.isFullscreen) {
      fullscreenButton.classList.add("on");
      if (typeof this._activeCallback === "function") {
        this._activeCallback();
      }
    } else {
      fullscreenButton.classList.remove("on");
      if (typeof this._inactiveCallback === "function") {
        this._inactiveCallback();
      }
    }
  }

  /**
   * 키 다운 시 전체화면 버튼 상태 업데이트.<br>
   * Update the fullscreen button state when a key is pressed.
   * @param {KeyboardEvent} e 키보드 이벤트 객체.<br> Keyboard event object.
   */
  documentKeydown(e) {
    if (e.code === "F11") {
      document.body.requestFullscreen();
      e.preventDefault();
    }
    // if (e.code === "Escape") {
    //   document.exitFullscreen();
    //   handleFullscreenChange(); // ESC 키를 눌렀을 때 전체화면 버튼의 상태를 업데이트합니다.
    // }
  }

  /**
   * 위젯 파괴. 영구적으로 제거하는 경우 호출.</br>
   * Destroys the widget.  Should be called if permanently removing the widget from layout.
   */
  destroy() {
    // 컨테이너에 요소 있는지 없는지
    if (this._container.getElementsByClassName("ditap-full-btn").length < 1) {
      this._container.appendChild(this.fullscreenButton);
    }

    super.destroy();

    if (this._resizeEvent) {
      window.removeEventListener("resize", this._resizeEvent);
    }

    this.fullscreenButton = undefined;
    this._container = undefined;
    this._element = undefined;
    this._viewModel = undefined;
  }

  /**
   * 전체화면 활성화 시 호출할 콜백 함수</br>
   * A callback function to be called when fullscreen is activated.
   * @type {function}
   */
  set callbackOnFullscreen(callback) {
    if (typeof callback === "function") {
      this._activeCallback = callback;
    } else {
      console.log("type of callback must be function");
    }
  }

  get callbackOnFullscreen() {
    return this._activeCallback;
  }

  /**
   * 전체화면 비활성화 시 호출할 콜백 함수</br>
   * A callback function to be called when exiting fullscreen mode.
   * @type {function}
   */
  set callbackOffFullscreen(callback) {
    if (typeof callback === "function") {
      this._inactiveCallback = callback;
    } else {
      console.log("type of callback must be function");
    }
  }

  get callbackOffFullscreen() {
    return this._inactiveCallback;
  }
}
export default DitapFullscreenButton;
